/** @format */
import { Address, AddressWithId } from '@toucan/client/global/transaction';

type AddressToBeTransformed = (Address | AddressWithId) & {
    line1?: string;
    line2?: string;
};

function createAddress(address: Partial<Address>) {
    const newAddress: Address = {
        ...address,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        addressee: address.addressee || '',
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        country: address.country || '',
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        county: address.county || '',
        id: address.id,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        line1: address.line1 || '',
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        line2: address.line2 || '',
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        nickname: address.nickname || '',
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        postcode: address.postcode || '',
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        state: address.state || '',
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        town: address.town || '',
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        verified: address.verified || false,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- Legacy code: do not use as an example.
        zipcode: address.zipcode || '',
    };

    if (address.country === 'US') {
        delete newAddress.county;
        delete newAddress.postcode;
    } else {
        delete newAddress.state;
        delete newAddress.zipcode;
    }

    return newAddress;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
export function transformInboundAddressData(address: any): AddressWithId {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
    const newAddress = createAddress({
        ...address,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        line1: address.addressLine1,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        line2: address.addressLine2,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        id: address.addressId,
    }) as AddressWithId;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
    if (address.country === 'US') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        newAddress.state = address.county;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
        newAddress.zipcode = address.postcode;
    }

    return newAddress;
}

export function transformOutboundAddressData<T extends AddressToBeTransformed>(
    address: T
): T {
    const { id, line1, line2, ...newAddress } = createAddress(address);

    return {
        ...newAddress,
        addressId: id,
        addressLine1: line1,
        addressLine2: line2,
    } as unknown as T;
}

export function transformAddressValidationErrors(
    validationErrors: Record<string, string>
): Record<string, string> {
    const { addressLine1, addressLine2, ...addressErrors } = validationErrors;
    if (addressLine1) {
        addressErrors.line1 = addressLine1;
    }
    if (addressLine2) {
        addressErrors.line2 = addressLine2;
    }

    return addressErrors;
}
